export default __webpack_public_path__ + "static/media/facebook.568e2b5e.svg";